import { Field } from "formik";

import { DISPOSITIONS_V3 } from "shared/lib/constants/dispositions";
import { clsxMerge } from "shared/lib/helpers";
import { ValueOfObjectFields } from "shared/lib/interfaces/utils";
import { Dropdown } from "shared/ui";
import { NextTouchTimeDropdown } from "./next-touch-time-dropdown";
import { DropdownOptionI } from "shared/ui/user-input/dropdown";

export const isNextTouchTimeRequired = (
  disposition?: ValueOfObjectFields<typeof DISPOSITIONS_V3>
) =>
  ![
    DISPOSITIONS_V3.DO_NOT_CALL as string,
    DISPOSITIONS_V3.QC_NOT_MET_FOR_ACCOUNT,
    DISPOSITIONS_V3.OTHER_DO_NOT_FOLLOW_UP,
  ].includes(disposition as string);

const EnhancedDropdown = Dropdown(Field);

export const DispositionRow = ({
  names,
  disposition,
  dispositionOptions,
  errors,
  touched,
  className,
  customNextTouchTime,
}: {
  names: Array<string>;
  disposition?: ValueOfObjectFields<typeof DISPOSITIONS_V3>;
  dispositionOptions: DropdownOptionI[];
  errors?: Record<string, string>;
  touched?: Record<string, boolean>;
  className?: string;
  customNextTouchTime?: string;
}) => {
  return (
    <div
      className={clsxMerge(
        "flex w-full animate-fadein flex-wrap items-center gap-x-4",
        className
      )}
    >
      <EnhancedDropdown
        //NOTE workaround for custom dispositions
        name={"internalDispositionId"}
        label="Disposition"
        placeholder="Select"
        options={dispositionOptions}
        errors={errors?.[names[0]]}
        touched={touched?.[names[0]]}
        className="relative mb-0 w-full max-w-[240px] animate-fadein"
        labelContentClassName="brand-typography-body2"
        inputClassName="text-black"
        errorsClassName="absolute -bottom-[22px] whitespace-nowrap"
      />

      {!!names[1] && isNextTouchTimeRequired(disposition) && (
        <NextTouchTimeDropdown
          name={names[1]}
          errors={errors?.[names[1]]}
          touched={touched?.[names[1]]}
          customNextTouchTime={customNextTouchTime}
        />
      )}
    </div>
  );
};
